export enum EquipmentType {
  Power = 'power',
  Trailer = 'trailer',
  Dolly = 'dolly',
}
